import {
  TDocumentsCategory,
  TDocumentsCollection,
  IDocumentsCategory,
  IDocumentsCollection,
} from './types'

export const DOCUMENTS_COLLECTION: Record<
  TDocumentsCollection,
  IDocumentsCollection
> = {
  lendingOffers: {
    key: 'lendingOffers',
    label: 'Lending offer',
    categoryOrder: 1,
    categoryKey: 'proposal',
  },
  supportingDocuments: {
    key: 'supportingDocuments',
    label: 'Supporting docs',
    categoryOrder: 2,
    categoryKey: 'proposal',
  },
  feasibility: {
    key: 'feasibility',
    label: 'Feasibility',
    categoryOrder: 3,
    categoryKey: 'proposal',
  },
  insurance: {
    key: 'insurance',
    label: 'Project insurance',
    categoryOrder: 1,
    categoryKey: 'legal',
  },
  postRegistrationTitles: {
    key: 'postRegistrationTitles',
    label: 'Post registration titles',
    categoryOrder: 2,
    categoryKey: 'legal',
  },
  ppsr: {
    key: 'ppsr',
    label: 'PPSR',
    categoryOrder: 3,
    categoryKey: 'legal',
  },
  loanDocuments: {
    key: 'loanDocuments',
    label: 'Loan docs',
    categoryOrder: 4,
    categoryKey: 'legal',
  },
  loanVariationDocuments: {
    key: 'loanVariationDocuments',
    label: 'Loan variation',
    categoryOrder: 5,
    categoryKey: 'legal',
  },
  loanDischargeDocuments: {
    key: 'loanDischargeDocuments',
    label: 'Loan discharge',
    categoryOrder: 6,
    categoryKey: 'legal',
  },
  developmentSitePhotos: {
    key: 'developmentSitePhotos',
    label: 'Photos',
    categoryOrder: 1,
    categoryKey: 'project',
  },
  resourceConsents: {
    key: 'resourceConsents',
    label: 'Resource consent',
    categoryOrder: 2,
    categoryKey: 'project',
  },
  engineeringPlanApprovals: {
    key: 'engineeringPlanApprovals',
    label: 'Engineering plan approval',
    categoryOrder: 3,
    categoryKey: 'project',
  },
  buildingConsents: {
    key: 'buildingConsents',
    label: 'Building consent',
    categoryOrder: 4,
    categoryKey: 'project',
  },
  drawdownNotices: {
    key: 'drawdownNotices',
    label: 'Drawdown notice',
    categoryOrder: 5,
    categoryKey: 'project',
  },
  invoices: {
    key: 'invoices',
    label: 'Invoices',
    categoryOrder: 6,
    categoryKey: 'project',
  },
  buildingInspections: {
    key: 'buildingInspections',
    label: 'Building inspections',
    categoryOrder: 7,
    categoryKey: 'project',
  },
  geotechAndSurveyReports: {
    key: 'geotechAndSurveyReports',
    label: 'Geotech & survey reports',
    categoryOrder: 8,
    categoryKey: 'project',
  },
  engineerReports: {
    key: 'engineerReports',
    label: 'Engineer reports',
    categoryOrder: 9,
    categoryKey: 'project',
  },
  utilityCertificationAndCompliance: {
    key: 'utilityCertificationAndCompliance',
    label: 'Utility certification & compliance',
    categoryOrder: 10,
    categoryKey: 'project',
  },
  qsReports: {
    key: 'qsReports',
    label: 'QS reports',
    categoryOrder: 11,
    categoryKey: 'project',
  },
  cccAndTitles: {
    key: 'cccAndTitles',
    label: 'CCC & titles',
    categoryOrder: 12,
    categoryKey: 'project',
  },
  preSales: {
    key: 'preSales',
    label: 'Pre-sales',
    categoryOrder: 13,
    categoryKey: 'project',
  },
  // next is condition files
  documents: {
    key: 'documents',
    label: 'Conditions files',
    categoryOrder: 14,
    categoryKey: 'project',
  },
  others: {
    key: 'others',
    label: 'Others',
    categoryOrder: 1,
    categoryKey: 'others',
  },
  attachment: {
    key: 'attachment',
    label: 'Chat',
    categoryOrder: 1,
    categoryKey: 'attachment',
  },
  aml: {
    key: 'aml',
    label: 'General',
    categoryOrder: 1,
    categoryKey: 'amlDocuments',
  },
  addressDocuments: {
    key: 'addressDocuments',
    label: 'Address documents',
    categoryOrder: 2,
    categoryKey: 'amlDocuments',
  },
  identityDocuments: {
    key: 'identityDocuments',
    label: 'Identity documents',
    categoryOrder: 3,
    categoryKey: 'amlDocuments',
  },
  other: {
    key: 'other',
    label: 'Other documents',
    categoryOrder: 4,
    categoryKey: 'amlDocuments',
  },
}

const documentsCollectionValues = Object.values(DOCUMENTS_COLLECTION)
const getDocumentsCategoryCollections = (category: TDocumentsCategory) =>
  documentsCollectionValues.filter(
    (collection) => collection.categoryKey === category
  )

export const DOCUMENTS_CATEGORY: Record<
  TDocumentsCategory,
  IDocumentsCategory
> = {
  amlDocuments: {
    key: 'amlDocuments',
    label: 'AML documents',
    order: 1,
  },
  proposal: {
    key: 'proposal',
    label: 'Proposal',
    order: 2,
    collections: getDocumentsCategoryCollections('proposal'),
  },
  legal: {
    key: 'legal',
    label: 'Legal docs',
    order: 3,
    collections: getDocumentsCategoryCollections('legal'),
  },
  drawdowns: {key: 'drawdowns', label: 'Drawdowns', order: 4},
  project: {
    key: 'project',
    label: 'Project files',
    order: 5,
    collections: getDocumentsCategoryCollections('project'),
  },
  others: {
    key: 'others',
    label: 'Others',
    title: 'other file',
    order: 6,
    collections: getDocumentsCategoryCollections('others'),
  },
  attachment: {
    key: 'attachment',
    label: 'Chat files',
    title: 'chat file',
    order: 7,
    collections: getDocumentsCategoryCollections('attachment'),
  },
}

export const SORT_ITEMS = [
  {key: 'date', label: 'Date'},
  {key: 'name', label: 'Name'},
  {key: 'size', label: 'Size'},
]
